/** @import Sociedad from '@/classes/facturae/Sociedad' */
/** @import Address from '@/classes/facturae/Address' */
/** @import ContactDetails from '@/classes/facturae/ContactDetails' */
/** @import AdminsitrativeCentre from '@/classes/facturae/AdminsitrativeCentre' */
/** @import FACeB2BIdentificatives from '@/classes/facturae/FACeB2BIdentificatives' */
/** @import AdminsitrativeCentreFACeB2B from '@/classes/facturae/AdminsitrativeCentreFACeB2B' */
export default class Receiver {
  /** @type {Sociedad} */ Sociedad = null
  /** @type {number} */ IdSociedad = null
  /** @type {number} */ IdSede = null
  /** @type {string} */ LocationName = null
  /** @type {string} */ SendType = null
  /** @type {Address} */ Address = null
  /** @type {ContactDetails} */ ContactDetails = null
  /** @type {Array<AdminsitrativeCentre>} */ AdminsitrativeCentres = null
  /** @type {FACeB2BIdentificatives} */ FACeB2BIdentificatives = null
  /** @type {Array<AdminsitrativeCentreFACeB2B>} */ AdminsitrativeCentresFACeB2B = null
}
